export const cacheKeys = {
  lists: "lists",
  user: "user",
  follows: 'follows',
  media: 'media',
  likes: 'likes',
  saves: 'saves',
  search: 'search',
  smartCollection: 'smart'
}